import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8a55bdac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "_page_wrap_clients" }
const _hoisted_2 = { class: "_page_block_clients" }
const _hoisted_3 = {
  class: "_block_piece",
  mark: "cate"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_block_title1 _priv_title" }, " 华美项目分类 ", -1))
const _hoisted_5 = { class: "_block_container" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "_cate_title" }
const _hoisted_8 = { class: "_block_content_wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_scroll_enter = _resolveComponent("scroll-enter")!
  const _component_Isotope = _resolveComponent("Isotope")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_Isotope, {
          activated: _ctx.windowWidth>600,
          class: "_block_piece_children",
          initialize: _ctx.isoInitialize,
          onNewWidth: _cache[0] || (_cache[0] = newWidth=>_ctx.handleNewWidth(newWidth, 'cate'))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageData, (b1, b1Index) => {
              return (_openBlock(), _createBlock(_component_scroll_enter, {
                class: "iso_item",
                _inactive: b1Index<4,
                duration: 1,
                key: b1.title
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("img", {
                      class: "_category_logo",
                      src: b1.image,
                      alt: "",
                      style: _normalizeStyle(`filter:${_ctx.filters[b1Index%_ctx.filters.length]}`)
                    }, null, 12, _hoisted_6),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(b1.title), 1),
                    _createElementVNode("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(b1.content.sort((a,b)=>_ctx.removeProvs(a).localeCompare(_ctx.removeProvs(b))), (b2) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "_block_content default_text",
                          key: b2
                        }, _toDisplayString(_ctx.removeProvs(b2)), 1))
                      }), 128))
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["_inactive"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["activated", "initialize"])
      ])
    ])
  ]))
}